import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Edit3, Camera, Package, Heart, LogOut, ChevronRight } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const Profile25 = () => {
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        firstName: 'Arjun', lastName: 'Mehta',
        email: 'arjun.mehta@email.com', phone: '+91 98765 43210',
        address: '42 Pali Hill Road, Bandra West',
        city: 'Mumbai', state: 'Maharashtra', pincode: '400050',
    });

    const handleInput = (e) => {
        const { name, value } = e.target;
        setProfile(prev => ({ ...prev, [name]: value }));
    };

    const inputStyle = {
        width: '100%', padding: '12px 16px',
        border: '1px solid #DEE2E6', background: '#FFFFFF',
        fontSize: 14, outline: 'none', color: '#111111',
        fontFamily: 'IBM Plex Sans, sans-serif',
        borderRadius: 0, transition: 'border-color 0.2s'
    };

    const labelStyle = {
        display: 'block', fontSize: 12, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: 8, fontFamily: 'Space Grotesk, sans-serif', color: '#6C757D'
    };

    const sidebarItems = [
        { key: 'profile', label: 'My Profile', icon: User },
        { key: 'orders', label: 'My Orders', icon: Package, link: '/template25/orders' },
        { key: 'wishlist', label: 'Wishlist', icon: Heart },
        { key: 'addresses', label: 'Addresses', icon: MapPin },
    ];

    const recentOrders = [
        { id: 'SAH-20260315-001', date: 'Mar 15, 2026', total: 9999, status: 'Delivered' },
        { id: 'SAH-20260312-002', date: 'Mar 12, 2026', total: 14999, status: 'Shipped' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-profile * { box-sizing: border-box; }
                .sahaj-profile { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-profile-heading { font-family: 'Space Grotesk', sans-serif; }
                .sahaj-profile input:focus { border-color: #0D7C66 !important; }
            `}</style>
            <div className="sahaj-profile" style={{ minHeight: '100vh' }}>
                <Header />

                <div style={{ maxWidth: 1280, margin: '0 auto', padding: '100px 24px 80px' }}>
                    <h1 className="sahaj-profile-heading" style={{
                        fontSize: 40, fontWeight: 700, marginBottom: 48, letterSpacing: '-1px'
                    }}>
                        MY ACCOUNT
                    </h1>

                    <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: 40 }}>
                        {/* Sidebar */}
                        <div>
                            {/* Avatar Card */}
                            <div style={{ background: '#F8F9FA', border: '1px solid #DEE2E6', padding: 32, textAlign: 'center', marginBottom: 24 }}>
                                <div style={{
                                    width: 100, height: 100, background: '#0D7C66',
                                    margin: '0 auto 16px', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', position: 'relative'
                                }}>
                                    <span className="sahaj-profile-heading" style={{ fontSize: 36, fontWeight: 700, color: '#FFFFFF' }}>
                                        {profile.firstName[0]}{profile.lastName[0]}
                                    </span>
                                    <button style={{
                                        position: 'absolute', bottom: -4, right: -4,
                                        width: 32, height: 32, background: '#111111', border: 'none',
                                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <Camera size={14} color="#FFFFFF" />
                                    </button>
                                </div>
                                <h3 className="sahaj-profile-heading" style={{ fontSize: 18, fontWeight: 700, margin: '0 0 4px' }}>
                                    {profile.firstName} {profile.lastName}
                                </h3>
                                <p style={{ fontSize: 13, color: '#6C757D', margin: 0 }}>{profile.email}</p>
                            </div>

                            {/* Nav */}
                            <div style={{ border: '1px solid #DEE2E6' }}>
                                {sidebarItems.map((item, idx) => (
                                    <button
                                        key={item.key}
                                        onClick={() => item.link ? navigate(item.link) : setActiveSection(item.key)}
                                        style={{
                                            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                            padding: '16px 20px', border: 'none',
                                            borderBottom: idx < sidebarItems.length - 1 ? '1px solid #DEE2E6' : 'none',
                                            background: activeSection === item.key ? '#E8F5F1' : '#FFFFFF',
                                            cursor: 'pointer', fontSize: 14, fontWeight: 500,
                                            color: activeSection === item.key ? '#0D7C66' : '#111111',
                                            fontFamily: 'IBM Plex Sans, sans-serif',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <item.icon size={18} />
                                            {item.label}
                                        </div>
                                        <ChevronRight size={16} color="#6C757D" />
                                    </button>
                                ))}
                                <button style={{
                                    width: '100%', display: 'flex', alignItems: 'center', gap: 12,
                                    padding: '16px 20px', border: 'none', borderTop: '1px solid #DEE2E6',
                                    background: '#FFFFFF', cursor: 'pointer', fontSize: 14,
                                    fontWeight: 500, color: '#DC3545',
                                    fontFamily: 'IBM Plex Sans, sans-serif'
                                }}>
                                    <LogOut size={18} />
                                    Sign Out
                                </button>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div>
                            {activeSection === 'profile' && (
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                        <h2 className="sahaj-profile-heading" style={{ fontSize: 24, fontWeight: 700, margin: 0, letterSpacing: '-0.5px' }}>
                                            PERSONAL INFORMATION
                                        </h2>
                                        <button
                                            onClick={() => setIsEditing(!isEditing)}
                                            style={{
                                                padding: '10px 24px', border: '1px solid #DEE2E6',
                                                background: isEditing ? '#0D7C66' : '#FFFFFF',
                                                color: isEditing ? '#FFFFFF' : '#111111',
                                                fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                                display: 'flex', alignItems: 'center', gap: 8,
                                                fontFamily: 'Space Grotesk, sans-serif',
                                                textTransform: 'uppercase', letterSpacing: '1px'
                                            }}
                                        >
                                            <Edit3 size={14} />
                                            {isEditing ? 'Save' : 'Edit'}
                                        </button>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 40 }}>
                                        {[
                                            { name: 'firstName', label: 'First Name', icon: User },
                                            { name: 'lastName', label: 'Last Name', icon: User },
                                            { name: 'email', label: 'Email', icon: Mail },
                                            { name: 'phone', label: 'Phone', icon: Phone },
                                        ].map(field => (
                                            <div key={field.name}>
                                                <label style={labelStyle}>{field.label}</label>
                                                {isEditing ? (
                                                    <input
                                                        name={field.name} value={profile[field.name]}
                                                        onChange={handleInput} style={inputStyle}
                                                    />
                                                ) : (
                                                    <p style={{ fontSize: 15, fontWeight: 500, margin: 0, padding: '12px 0' }}>
                                                        {profile[field.name]}
                                                    </p>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ borderTop: '1px solid #DEE2E6', paddingTop: 32 }}>
                                        <h3 className="sahaj-profile-heading" style={{
                                            fontSize: 18, fontWeight: 700, marginBottom: 20,
                                            textTransform: 'uppercase', letterSpacing: '0.5px'
                                        }}>
                                            Default Address
                                        </h3>
                                        {isEditing ? (
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16, maxWidth: 500 }}>
                                                <div>
                                                    <label style={labelStyle}>Address</label>
                                                    <input name="address" value={profile.address} onChange={handleInput} style={inputStyle} />
                                                </div>
                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                                                    <div>
                                                        <label style={labelStyle}>City</label>
                                                        <input name="city" value={profile.city} onChange={handleInput} style={inputStyle} />
                                                    </div>
                                                    <div>
                                                        <label style={labelStyle}>State</label>
                                                        <input name="state" value={profile.state} onChange={handleInput} style={inputStyle} />
                                                    </div>
                                                    <div>
                                                        <label style={labelStyle}>PIN Code</label>
                                                        <input name="pincode" value={profile.pincode} onChange={handleInput} style={inputStyle} />
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{ padding: 24, background: '#F8F9FA', border: '1px solid #DEE2E6', maxWidth: 500 }}>
                                                <p style={{ fontSize: 15, lineHeight: 1.6, margin: 0 }}>
                                                    {profile.address}<br />
                                                    {profile.city}, {profile.state} - {profile.pincode}
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Recent Orders */}
                                    <div style={{ borderTop: '1px solid #DEE2E6', paddingTop: 32, marginTop: 32 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                                            <h3 className="sahaj-profile-heading" style={{
                                                fontSize: 18, fontWeight: 700, margin: 0,
                                                textTransform: 'uppercase', letterSpacing: '0.5px'
                                            }}>
                                                Recent Orders
                                            </h3>
                                            <span
                                                onClick={() => navigate('/template25/orders')}
                                                style={{ fontSize: 13, color: '#0D7C66', fontWeight: 600, cursor: 'pointer' }}
                                            >
                                                View All →
                                            </span>
                                        </div>
                                        {recentOrders.map(order => (
                                            <div key={order.id} style={{
                                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                padding: '16px 20px', border: '1px solid #DEE2E6', marginBottom: 8
                                            }}>
                                                <div>
                                                    <span className="sahaj-profile-heading" style={{ fontSize: 14, fontWeight: 600 }}>#{order.id}</span>
                                                    <span style={{ fontSize: 13, color: '#6C757D', marginLeft: 16 }}>{order.date}</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                    <span style={{
                                                        padding: '4px 12px', background: '#E8F5F1', color: '#0D7C66',
                                                        fontSize: 12, fontWeight: 600
                                                    }}>
                                                        {order.status}
                                                    </span>
                                                    <span className="sahaj-profile-heading" style={{ fontWeight: 700 }}>
                                                        ₹{order.total.toLocaleString('en-IN')}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {activeSection === 'wishlist' && (
                                <div>
                                    <h2 className="sahaj-profile-heading" style={{ fontSize: 24, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px' }}>
                                        MY WISHLIST
                                    </h2>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
                                        {[
                                            { name: 'Silk Blend Saree', price: 9500, image: 'https://images.pexels.com/photos/12045033/pexels-photo-12045033.jpeg?auto=compress&cs=tinysrgb&w=400' },
                                            { name: 'Modern Sherwani Set', price: 18999, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
                                        ].map((item, idx) => (
                                            <div key={idx} style={{ border: '1px solid #DEE2E6', cursor: 'pointer' }} onClick={() => navigate('/template25/product')}>
                                                <div style={{ aspectRatio: '1/1', overflow: 'hidden' }}>
                                                    <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                </div>
                                                <div style={{ padding: 16 }}>
                                                    <h4 className="sahaj-profile-heading" style={{ fontSize: 15, fontWeight: 600, margin: '0 0 8px' }}>{item.name}</h4>
                                                    <p className="sahaj-profile-heading" style={{ fontSize: 16, fontWeight: 700, margin: '0 0 12px' }}>₹{item.price.toLocaleString('en-IN')}</p>
                                                    <button style={{
                                                        width: '100%', padding: '10px', background: '#0D7C66', color: '#FFFFFF',
                                                        border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                                                        textTransform: 'uppercase', letterSpacing: '1px',
                                                        fontFamily: 'Space Grotesk, sans-serif'
                                                    }}>
                                                        Add to Cart
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {activeSection === 'addresses' && (
                                <div>
                                    <h2 className="sahaj-profile-heading" style={{ fontSize: 24, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px' }}>
                                        SAVED ADDRESSES
                                    </h2>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                                        <div style={{ padding: 24, border: '2px solid #0D7C66', position: 'relative' }}>
                                            <span style={{
                                                position: 'absolute', top: 12, right: 12,
                                                padding: '4px 10px', background: '#E8F5F1', color: '#0D7C66',
                                                fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px'
                                            }}>Default</span>
                                            <h4 className="sahaj-profile-heading" style={{ fontSize: 15, fontWeight: 700, margin: '0 0 8px' }}>Home</h4>
                                            <p style={{ fontSize: 14, color: '#6C757D', lineHeight: 1.6, margin: 0 }}>
                                                {profile.address}<br />{profile.city}, {profile.state} - {profile.pincode}
                                            </p>
                                        </div>
                                        <button style={{
                                            padding: 24, border: '2px dashed #DEE2E6', background: '#F8F9FA',
                                            cursor: 'pointer', display: 'flex', flexDirection: 'column',
                                            alignItems: 'center', justifyContent: 'center', gap: 8
                                        }}>
                                            <span style={{ fontSize: 24, color: '#0D7C66', fontWeight: 300 }}>+</span>
                                            <span className="sahaj-profile-heading" style={{ fontSize: 14, fontWeight: 600, color: '#6C757D' }}>Add New Address</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Profile25;
